<template>
<div class="aboutbox">
  <div class="banner flex a-c ">
  <div class=" title" >
      <div>
      公司介绍
    </div>
    <div class="flex cubebox">
      <div>Branded Content</div>
    </div>
  </div>
  </div>
  <div class="about">
    <div class="flex link">
      <div>
        <p class="blc">{{ $t("message.agent") }}</p>
        <div class="flex a-c flex-c">
          <div class="dot"></div>
          <p style="color: #3c64de" @click="linkus">{{ $t("message.contact") }}</p>
        </div>
      </div>
      <div>
        <p class="blc">{{ $t("message.cooperation") }}</p>
        <div class="flex a-c flex-c">
          <div class="dot"></div>
        <p style="color: #3c64de" @click="linkus">{{ $t("message.contact") }}</p>
        </div>
      </div>
      <div>
        <p class="blc">{{ $t("message.with") }}</p>
        <div class="flex a-c flex-c">
          <div class="dot"></div>
        <p style="color: #3c64de">{{ $t("message.email") }}：334249689@qq.com</p>
        </div>
      </div>
    </div>
    <div class="flex wordintroduce">
      <div class="imgbox">
        <img
          :src="companyInfo.image"
          alt=""
        />
      </div>
      <div class="richContent">
        <div class="company">
          公司介绍：
        </div>
        <div class="line"></div>
       <p>{{companyInfo.introMessage}}</p>
      </div>
    </div>
  <linkService ref="linkservice" ></linkService>
  </div>
</div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import linkService from '@/components/linkService.vue'
import { companyIntroApi } from "@/api/index.js";
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
let  linkservice = ref(null)
const linkus = ()=> {  
    linkservice.value.dialogVisible = true
}
onMounted(() => {
  getList();
});
let companyInfo = ref({})
const getList = ()=>{
   companyIntroApi()
    .then((res) => {
      companyInfo.value = res
    })
    .catch((err) => {
      console.log(err);
    });
}
</script>
<style scoped lang='scss'>
.about {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0;
  .imgbox {
    width: 534px;
    height: 349px;
  }
  .wordintroduce {
    width: 1200px;
    display: flex;
    align-items: center;
  }
  .richContent {
    margin-left: 20px;
    flex: 1;
    text-align: left;
    color: #a1a1a1;
    font-size: 20px;
    p {
      line-height: 30px;
    }
  }
  .blc {
    color: #000;
    font-size: 24px;
    margin-bottom: 10px;
  }
  .link {
    width: 1200px;
    display: flex;
    justify-content: space-around;
    margin: 20px 0 80px;
  }
   img{
        width: 100%;
        height: 100%;
        border-radius: 10px;
    }
}
.banner{
 width: 100%;
 height: 210px;
 background-image: url('../../assets/about.png')  ;
 background-size: 100% 100%;
 position: relative;
}
.title{
  color: #ffffff;
  font-size: 30px;
  position: absolute;
  left: 475px;
  font-weight: normal;
}
.cubebox{
  font-size: 25px;
}
.cube{
  width: 70px;
  height: 24px;
  background-color: #fff;
  border-radius: 5px;
  margin-right: 5px;
}
.dot{
  width: 10px;
  height: 10px;
  background-color: #e6a9b9;
  border-radius: 50%;
  margin-right: 5px;
}
.company{
  color: #737373;
  font-size: 30px;
}
.line{
  width: 30px;
  height: 2px;
  background-color: #d24670;
  margin: 0 4px 10px;
}
</style>